import { emptyValidator, formValidator } from "../../validators";

const rateValidationStatus = {
  rahRateTypeFor: {
    validators: [emptyValidator()],
    name: "Rate Type",
  },
  rahReference: {
    validators: [emptyValidator()],
    name: "Customer/Supplier",
  },
  rahRevcost: {
    validators: [emptyValidator()],
    name: "Revenue/Cost",
  },
  rahCharge: {
    validators: [emptyValidator()],
    name: "Charge",
  },
  rehPattern: {
    validators: [emptyValidator()],
    name: "Pattern",
  },
  rahName: {
    validators: [emptyValidator()],
    name: "Rate Name",
  },
  rahVehcon: {
    validators: [emptyValidator()],
    name: "Vehicle/Container Type",
  },
  rahAddDeduct: {
    validators: [emptyValidator()],
    name: "Add/Deduct",
  },
  rahCustomer: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  rahShipper: {
    validators: [emptyValidator()],
    name: "Shipper",
  },
  rahCalcType: {
    validators: [emptyValidator()],
    name: "Calculation Type",
  },
  rahCurrency: {
    validators: [emptyValidator()],
    name: "Currency",
  },
  rahUom: {
    validators: [emptyValidator()],
    name: "UOM",
  },
  rahFormular: {
    validators: [emptyValidator()],
    name: "Formula",
  },
  rahFromDate: {
    validators: [emptyValidator()],
    name: "From Date",
  },
  rahStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  rahActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  rahCelling: {
    validators: [emptyValidator()],
    name: "Ceiling",
  },
};

export const rateValidation = (rate) => {
  return formValidator(rate, rateValidationStatus);
};
